import apiInstance from '../utils/axiosConfig';

const ContactService = {
    // Créer un nouveau contact
    createContact: async (contactRequestDTO) => {
        try {
            const response = await apiInstance.post('/contacts', contactRequestDTO);
            return response.data;
        } catch (error) {
            console.error('Error creating contact:', error.response?.data || error.message);
            throw error;
        }
    },

    // Récupérer un contact par ID
    getContactById: async (id) => {
        try {
            const response = await apiInstance.get(`/contacts/${id}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching contact by id:', error.response?.data || error.message);
            throw error;
        }
    },

    // Récupérer tous les contacts
    getAllContacts: async () => {
        try {
            const response = await apiInstance.get('/contacts');
            return response.data;
        } catch (error) {
            console.error('Error fetching all contacts:', error.response?.data || error.message);
            throw error;
        }
    },

    // Récupérer les contacts par email
    getContactsByEmail: async (email) => {
        try {
            const response = await apiInstance.get(`/contacts/email/${email}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching contacts by email:', error.response?.data || error.message);
            throw error;
        }
    },

    // Récupérer les contacts non traités
    getUnprocessedContacts: async () => {
        try {
            const response = await apiInstance.get('/contacts/unprocessed');
            return response.data;
        } catch (error) {
            console.error('Error fetching unprocessed contacts:', error.response?.data || error.message);
            throw error;
        }
    },

    // Marquer un contact comme traité
    markAsProcessed: async (id) => {
        try {
            const response = await apiInstance.put(`/contacts/${id}/mark-processed`);
            return response.data;
        } catch (error) {
            console.error('Error marking contact as processed:', error.response?.data || error.message);
            throw error;
        }
    },

    // Supprimer un contact
    deleteContact: async (id) => {
        try {
            await apiInstance.delete(`/contacts/${id}`);
        } catch (error) {
            console.error('Error deleting contact:', error.response?.data || error.message);
            throw error;
        }
    },

    // Récupérer un contact par référence
    getContactByReference: async (reference) => {
        try {
            const response = await apiInstance.get(`/contacts/reference/${reference}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching contact by reference:', error.response?.data || error.message);
            throw error;
        }
    }
};

export default ContactService;